export default "__VITE_ASSET__B$5tzKCb__"